export enum ObjectTypeNum {
    Invalid             = 0,
    App                 = 1,
    Org                 = 2,
    Role                = 3,
    Task                = 4,
    Note                = 5,
    Group               = 6,
    Action              = 7,
    Invite              = 8,
    Person              = 9,
    Contact             = 10,
    Project             = 11,
    Chat                = 12,
    Notification        = 13,
    Invitation          = 14,
    Department          = 15,
    OrgStatus           = 16,
    CalendarEvent       = 17,
    OrgStatusType       = 18,
    Mention             = 19,
    IncomingCall        = 20,
    Tag                 = 21,
    KanbanBoard         = 22,
    File                = 23,
    Plugin              = 24,
    ChatMessage         = 25,
    Token               = 26,
    VideoDemo           = 27,
    IntegrationSetup    = 28,
    Workflow            = 29,
    Prefs               = 30,
    TasksFilter         = 31,
    WikiDoc             = 32,
    Tasktype            = 33,
    UrlPreview          = 34,
    Milestone           = 35,
}

export enum ObjectType {
    App = 'app',
    Org = 'org',
    Tag = 'tag',
    Chat = 'chat',
    File = 'file',
    Role = 'role',
    Task = 'task',
    Group = 'group',
    Prefs = 'prefs',
    Action = 'action',
    Invite = 'invite',
    Person = 'person',
    Plugin = 'plugin',
    Contact = 'contact',
    Project = 'project',
    WikiDoc = 'wikidoc',
    Tasktype = 'tasktype',
    KanbanBoard = 'board',
    Workflow = 'workflow',
    ChatMention = 'mention',
    Milestone = 'milestone',
    Department = 'department',
    Invitation = 'invitation',
    UrlPreview = 'urlpreview',
    ChatMessage = 'chatmessage',
    TasksFilter = 'tasksfilter',
    UserOrgStatus = 'orgstatus',
    Notification = 'notification',
    IncomingCall = 'incomingcall',
    CalendarEvent = 'calendarevent',
    UserOrgStatusType = 'orgstatustype',
    IntegrationSetup = 'integrationsetup',

    _GroupOrPerson = '_grouporperson',
}

export const ObjectTypeIcon: { [T in ObjectType]: string } = {
    [ObjectType.App]: 'vzi-site',
    [ObjectType.Org]: 'vzi-org',
    [ObjectType.Tag]: 'vzi-tag-lines',
    [ObjectType.Chat]: 'vzi-chat',
    [ObjectType.File]: 'vzi-attachment',
    [ObjectType.Role]: 'vzi-worker',
    [ObjectType.Task]: 'vzi-completed',
    [ObjectType.Group]: 'vzi-team',
    [ObjectType.Prefs]: 'vzi-settings',
    [ObjectType.Action]: 'vzi-note',
    [ObjectType.Invite]: 'vzi-user-add',
    [ObjectType.Person]: 'vzi-person-o',
    [ObjectType.Plugin]: 'vzi-yingyang',
    [ObjectType.Contact]: 'vzi-email',
    [ObjectType.Project]: 'vzi-project',
    [ObjectType.WikiDoc]: 'vzi-file-word',
    [ObjectType.Tasktype]: 'vzi-all-tasks',
    [ObjectType.ChatMention]: 'vzi-comment-o',
    [ObjectType.Milestone]: 'vzi-target',
    [ObjectType.Department]: 'vzi-house',
    [ObjectType.Invitation]: 'vzi-user-add',
    [ObjectType.UrlPreview]: 'vzi-link',
    [ObjectType.ChatMessage]: 'vzi-comment-o',
    [ObjectType.TasksFilter]: 'vzi-filter',
    [ObjectType.KanbanBoard]: 'vzi-kanban',
    [ObjectType.Workflow]: 'vzi-integration2',
    [ObjectType.Notification]: 'vzi-bell-o',
    [ObjectType.IncomingCall]: 'vzi-phone',
    [ObjectType.UserOrgStatus]: 'vzi-info',
    [ObjectType.CalendarEvent]: 'vzi-calendar1',
    [ObjectType.UserOrgStatusType]: 'vzi-info',
    [ObjectType.IntegrationSetup]: 'vzi-webhooks',

    [ObjectType._GroupOrPerson]: 'vzi-team',
}

export const ObjectTypePath: { [T in ObjectType]: ((orgId: string, id: string) => string) | undefined } = {
    [ObjectType.App]: (orgId, id) => `/ui/${orgId}/settings/apps/${id}`,
    [ObjectType.Org]: (orgId, _id) => `/ui/${orgId}/settings/org`,
    [ObjectType.Tag]: (orgId, id) => `/ui/${orgId}/settings/tags/${id}`,
    [ObjectType.Chat]: (orgId, id) => `/ui/${orgId}/chats/${id}`,
    [ObjectType.File]: undefined,
    [ObjectType.Role]: (orgId, id) => `/ui/${orgId}/settings/roles/${id}`,
    [ObjectType.Task]: (orgId, id) => `/ui/${orgId}/tasks/${id}`,
    [ObjectType.Group]: (orgId, id) => `/ui/${orgId}/settings/groups/${id}`,
    [ObjectType.Prefs]: undefined,
    [ObjectType.Action]: undefined,
    [ObjectType.Invite]: (orgId, id) => `/ui/${orgId}/settings/invites/${id}`,
    [ObjectType.Person]: (orgId, id) => `/ui/${orgId}/employees/${id}`,
    [ObjectType.Plugin]: (orgId, id) => `/ui/${orgId}/settings/plugins/${id}`,
    [ObjectType.Contact]: undefined,
    [ObjectType.Project]: (orgId, id) => `/ui/${orgId}/projects/${id}`,
    [ObjectType.WikiDoc]: (orgId, id) => `/ui/${orgId}/wiki/${id}`,
    [ObjectType.Tasktype]: undefined,
    [ObjectType.ChatMention]: undefined,
    [ObjectType.Milestone]: undefined,
    [ObjectType.Department]: (orgId, id) => `/ui/${orgId}/settings/deps/${id}`,
    [ObjectType.Invitation]: (orgId, _id) => `/ui/${orgId}/settings/profile`,
    [ObjectType.ChatMessage]: undefined,
    [ObjectType.UrlPreview]: undefined,
    [ObjectType.TasksFilter]: undefined,
    [ObjectType.KanbanBoard]: (orgId, id) => `/ui/${orgId}/kanban/${id}`,
    [ObjectType.Workflow]: (orgId, id) => `/ui/${orgId}/workflows/${id}`,
    [ObjectType.Notification]: undefined,
    [ObjectType.IncomingCall]: undefined,
    [ObjectType.UserOrgStatus]: undefined,
    [ObjectType.CalendarEvent]: (orgId, id) => `/ui/${orgId}/events/${id}`,
    [ObjectType.UserOrgStatusType]: (orgId, id) => `/ui/${orgId}/settings/statuses/${id}`,
    [ObjectType.IntegrationSetup]: (orgId, id) => `/ui/${orgId}/settings/integrations/${id}`,
    [ObjectType._GroupOrPerson]: undefined,
}
